/** Payload shape for `tags_doctor` on POST doctors/ms/v1/medical-record/psicology */
export type PsychologyTagsDoctorItem = { id: string }

export function buildTagsDoctorPayload(
  tagIds: string[] | undefined
): PsychologyTagsDoctorItem[] {
  return (tagIds || []).map((id) => ({ id }))
}
